<template>
  <MDBChip class="spa-lozenge" :class="customClass">
    {{ props.text }}
    <slot />
  </MDBChip>
</template>
<style lang="scss" scoped>
.spa-lozenge {
  height: unset;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  padding: 0 4px;
  margin: 0;
  text-transform: uppercase;
  border-radius: 2px;
  letter-spacing: 0.04em;
  color: $neutral-0;
  border: 1px solid transparent;
  &.default {
    background-color: $neutral-400;
  }
  &.pending {
    background-color: $yellow-300;
    color: $yellow-500;
  }
  &.warning {
    background-color: $orange-300;
  }
  &.error {
    background-color: $red-200;
  }
  &.info {
    background-color: $blue-300;
  }
  &.success {
    background-color: $green-300;
  }
  &.secondary-default {
    background-color: $neutral-400;
  }
  &.secondary-pending {
    background-color: $yellow-50;
    color: $yellow-500;
  }
  &.secondary-warning {
    background-color: $orange-300;
  }
  &.secondary-error {
    background-color: $red-200;
  }
  &.secondary-info {
    background-color: $blue-50;
    color: $blue-300;
  }
  &.secondary-success {
    background-color: $green-50;
    color: $green-300;
  }
  &.outlined {
    background-color: $neutral-0;
    &.default {
      border-color: $neutral-400;
      color: $neutral-400;
    }
    &.pending {
      border-color: $yellow-400;
      color: $yellow-400;
    }
    &.warning {
      border-color: $orange-300;
      color: $orange-300;
    }
    &.error {
      border-color: $red-200;
      color: $red-200;
    }
    &.info {
      border-color: $blue-300;
      color: $blue-300;
    }
    &.success {
      border-color: $green-300;
      color: $green-300;
    }
  }
  &.disabled {
    pointer-events: none;
    &.default {
      background-color: $neutral-40;
      color: $neutral-400;
    }
    &.pending {
      background-color: $yellow-50;
      color: $yellow-500;
    }
    &.warning {
      background-color: $orange-50;
      color: $orange-300;
    }
    &.error {
      background-color: $orange-50;
      color: $red-200;
    }
    &.info {
      background-color: $blue-50;
      color: $blue-300;
    }
    &.success {
      background-color: $green-50;
      color: $green-300;
    }
  }
}
.fit-content {
  width: fit-content;
}
</style>
<script>
import { MDBChip } from 'mdb-vue-ui-kit';
import { computed } from 'vue';
export default {
  name: 'SPALozenge',
  components: {
    MDBChip,
  },
  props: {
    text: {
      type: String,
      default: '',
      required: true,
    },
    variant: {
      type: String,
      default: 'default',
      validator(value) {
        return ['default', 'pending', 'warning', 'error', 'info', 'success'].includes(value);
      },
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    fitContent: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const customClass = computed(() => [props.variant, { outlined: props.outlined }, { disabled: props.disabled }, { 'fit-content': props.fitContent }]);
    return { props, customClass };
  },
};
</script>
